import { render } from "./WhistlistView.vue?vue&type=template&id=0ff3eb3e"
import script from "./WhistlistView.vue?vue&type=script&lang=js"
export * from "./WhistlistView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__